import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription, interval } from 'rxjs';
import { Deployment } from 'src/app/core/models/deployment';
import { CloudTypes, Entities } from 'src/app/core/models/globals';
import { UserRoleNames } from 'src/app/core/models/users';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { HeaderService } from 'src/app/core/services/header.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { SyncConfigService } from 'src/app/core/services/sync-config.service';

@Component({
  selector: 'app-job-parent-list',
  templateUrl: './job-parent-list.component.html',
  styleUrls: ['./job-parent-list.component.scss']
})
export class JobParentListComponent implements OnInit {

  toShow: boolean;
  deployments: Deployment[];
  clickedDepName: string = '';
  dataReloadSubscription: Subscription;
  dataEmpty: boolean = false;
  jobDeploymentListSub: Subscription;
  p: number = 1;

  constructor(
    private spiner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private sharedData: NavigationService,
    public depService: DeploymentService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    private headerService: HeaderService,
    private syncConfig: SyncConfigService
  ) {}

  ngOnInit(): void {
    this.spiner.show();
    this.sharedData.subNavData(Entities.Jobs);
    this.loadJobList()
    this.dataReloadSubscription = interval(this.syncConfig.config.deployments.listReqInterval + 1500000).subscribe((x) => {
      this.loadJobList();
    });
    this.sharedData.sendLeftPanelIndex(0);
  }

  loadJobList(){
    if(this.jobDeploymentListSub) this.jobDeploymentListSub.unsubscribe();
    this.deployments = this.depService.getProfileInfoesFromSubject()?.filter(x => x.status == 'Active' && !x.isVdi);
    if(this.deployments){
      this.manageData(this.deployments)
      // return;
    }
    this.jobDeploymentListSub = this.depService.getAllDeploymentsForUser()
      .subscribe({
        next: (data) => {
          this.manageData(data)
        },
        error: (error) => {
          this.dataEmpty = true;
          this.spiner.hide();
          if(this.authenticationService.currentUserValue.role == UserRoleNames.GlobalAdmin){
            //this.router.navigate(['/Deployment List'])
          }
        }
      });
  }

  manageData(data){
    if(!data || data.length == 0) {
      this.spiner.hide()
      this.dataEmpty = true;
      if(this.authenticationService.currentUserValue.role == UserRoleNames.GlobalAdmin){
       // this.router.navigate(['/Deployment List'])
      }
    } else {
      let isVdi = false;
      this.deployments = <Deployment[]>JSON.parse(JSON.stringify(data));
      this.deployments = this.deployments.filter(x => x.status == 'Active');
      this.headerService.updateDeploymentList(this.deployments);
      if (this.deployments.length != 0) {
        isVdi = this.deployments.every((d) => d.isVdi || d.cloud == CloudTypes.KVM);
      } 
      if (isVdi && this.headerService.toRedirectSessions) {
        this.router.navigate(['/Session List'])
        this.headerService.toRedirectSessions = false;
        return;
      } else {
        this.deployments = this.deployments.filter(x => !x.isVdi);
      }
      // uncomment if redirect to deployment is required in case of both hpc and vdi deployments.
      // let isMixed = this.deployments.some((d) => d.numOfComputeNodes == -1);
      // if (!isVdi && isMixed && this.headerService.toRedirectDeployments && this.deployments.length > 0) {
      //   this.router.navigate(['/Deployment List'])
      //   this.headerService.toRedirectDeployments = false;
      // }
      if(this.deployments.length == 0) {
        this.dataEmpty = true;
        this.spiner.hide();
        return;
      } else {
        this.dataEmpty = false;
        if (!this.deployments[1]) {
          this.redirectTo(this.deployments[0]);
        }
        this.spiner.hide();
      }
    }
  }

  ngOnDestroy() {
    if (this.dataReloadSubscription) {
      this.dataReloadSubscription.unsubscribe();
    }
    if(this.jobDeploymentListSub) this.jobDeploymentListSub.unsubscribe();
  }

  redirectTo(deployment: Deployment) {
    this.clickedDepName = deployment.name;
    this.sharedData.sendChildData(this.clickedDepName);
    this.sharedData.sendCloud(deployment.cloud);
    this.storageService.sendActiveStorageName(deployment.storageAccountName)
    this.router.navigate([deployment.cloud, this.clickedDepName], { relativeTo: this.route });
  }
}
